import React from 'react';
import type { Moneda } from '../../libs/moneda';
import '../landing/brand.css';

export type Currency = Moneda; // 'ARS' | 'USD' | 'constante'

/** Toggle ARS/USD/Const. compartido por las páginas públicas de precios (manual de marca v1.0). */
const CurrencyToggle: React.FC<{
  value: Currency;
  onChange: (c: Currency) => void;
  disabled?: boolean; // USD no disponible (sin cotización blue)
  usdRate?: number | null;
  uvaAvailable?: boolean; // Const. no disponible (sin CER)
}> = ({ value, onChange, disabled, usdRate, uvaAvailable = true }) => (
  <div className="lp-scope lp-seg" role="group" aria-label="Moneda">
    {(['ARS', 'USD', 'constante'] as Currency[]).map((c) => {
      const isDisabled =
        (c === 'USD' && disabled) ||
        (c === 'constante' && !uvaAvailable);
      const active = value === c;
      return (
        <button
          key={c}
          type="button"
          disabled={isDisabled}
          onClick={() => onChange(c)}
          aria-pressed={active}
          title={
            c === 'constante'
              ? 'Pesos constantes de hoy (ajustado por CER)'
              : c === 'USD' && disabled
              ? 'Dólar no disponible'
              : undefined
          }
          className={active ? 'on' : undefined}
        >
          {c === 'constante' ? 'Const.' : c}
          {c === 'USD' && usdRate ? <small>{` · $${usdRate.toFixed(0)}`}</small> : null}
        </button>
      );
    })}
  </div>
);

export default CurrencyToggle;
